import { Menu as BaseMenu } from './Menu'
import { MenuItem } from './MenuItem'

export * from './Menu'
export * from './MenuItem'

export const Menu = Object.assign(BaseMenu, { Item: MenuItem })
